import { api } from '@/api';
import router from '@/router';
import Axios, { AxiosError } from 'axios';
import { getStoreAccessors } from 'typesafe-vuex';
import { ActionContext } from 'vuex';
import { State } from '../state';
import { LandingPageState} from './state';
import { dispatchCheckApiError } from '../main/actions';
import { commitAccountCreationResult, commitSetProfiles } from './mutations';
import {
    commitSetStates, 
    commitSetCities, 
    commitSetCountries, 
    commitSetLanguages, 
    commitSetCurrencies } from './mutations';
import { IAccountCreateDash } from '@/interfaces';

type MainContext = ActionContext<LandingPageState, State>;

export const actions = {
    async getAccountProfiles(context: MainContext) {
        try {
            const response = await api.getAccountProfilesOpen();
            if (response.data) {
                commitSetProfiles(context, response.data);
            }
        } catch ( err ) {
            await dispatchCheckApiError(context, err);
        }
    },
    async getStates(context: MainContext, payload) {
        try {
            const response = await api.getStates(payload);
            if (response.data) {
                commitSetStates(context, response.data);
            }
        } catch ( err ) {
            await dispatchCheckApiError(context, err);
        }
    }, 
    async getCities(context: MainContext, payload) {
        try {
            const response = await api.getCities(payload);
            if (response.data) {
                commitSetCities(context, response.data);
            }
        } catch ( err ) {
            await dispatchCheckApiError(context, err);
        }
    }, 
    async getCountries(context: MainContext) {
        try {
            const response = await api.getCountries();
            if (response.data) {
                commitSetCountries(context, response.data);
            }
        } catch ( err ) {
            await dispatchCheckApiError(context, err);
        }
    }, 
    async getLanguages(context: MainContext) {
        try {
            const response = await api.getLanguages();
            if (response.data) {
                commitSetLanguages(context, response.data);
            }
        } catch ( err ) {
            await dispatchCheckApiError(context, err);
        }
    }, 
    async getCurrencies(context: MainContext) {
        try {
            const response = await api.getCurrencies();
            if (response.data) {
                commitSetCurrencies(context, response.data);
            }
        } catch ( err ) {
            await dispatchCheckApiError(context, err);
        }
    }, 
    async createAccount(context: MainContext, payload: IAccountCreateDash) {
        try {
            const response = await api.createAccount(payload);
            commitAccountCreationResult(context, {success: true});
        } catch (err) {
            var code : string | any = "500";
            var message = "";
            if((err as AxiosError).code) {
                code = (err as AxiosError).code;
            } 

            if (parseInt(code) >= 400 ){
                message = (err as AxiosError).response?.data as string;
            }
            commitAccountCreationResult(context, {success:false, error_message:message})
        }
    }
};

const { dispatch } = getStoreAccessors<LandingPageState | any, State>('');

export const dispatchGetAccountProfiles = dispatch(actions.getAccountProfiles);
export const dispatchGetStates = dispatch(actions.getStates);
export const dispatchGetCities = dispatch(actions.getCities);
export const dispatchGetCountries = dispatch(actions.getCountries);
export const dispatchGetLanguages = dispatch(actions.getLanguages);
export const dispatchGetCurrencies = dispatch(actions.getCurrencies);
export const dispatchCreateAccount = dispatch(actions.createAccount);